import {
	Grid,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Typography,
} from "@material-ui/core";
// import Axios from "axios";
import "date-fns/locale/pt-BR";
import numeral from "numeral";
import React from "react";

const PedidoResumo = (props) => {

  function formatDateToLocale(date){
    if(date){
      const dateToLocale = date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + 'T00:00';
      const dateToConvert = new Date(dateToLocale);
      return dateToConvert.toLocaleString('pt-BR', { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
  }

	return (
		<React.Fragment>
			<Paper className="p-1 mb-1">
				<Typography variant="caption" className="p-0 m-0" gutterBottom>
					Produtos
				</Typography>
				<Grid container spacing={3}>
					<Grid item md={12}>
						<div style={{ maxHeight: 200, overflow: "auto" }}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Produto ID</TableCell>
										<TableCell align="center">Quantidade </TableCell>
										<TableCell align="center">Valor</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{props.pedido.aItem.map((produto, index) => {
										return (
											<TableRow key={produto.cProduto}>
												<TableCell>
													<Typography
														variant="body2"
														className="p-0 m-0"
														gutterBottom
													>
														{produto.cProduto}
													</Typography>
												</TableCell>
												<TableCell align="center">
													<Typography
														variant="body2"
														className="p-0 m-0"
														gutterBottom
													>
														{produto.nQuantidade}
													</Typography>
												</TableCell>
												<TableCell align="right">
													<Typography
														variant="body2"
														className="p-0 m-0"
														gutterBottom
													>
														{produto.nValorNegociado.toLocaleString("pt-BR", {
															style: "currency",
															currency: "BRL",
														})}
													</Typography>
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</div>
					</Grid>
				</Grid>
			</Paper>
			<Paper className="p-1 mb-1">
				<Typography variant="caption" className="p-0 m-0" gutterBottom>
					Parcelas
				</Typography>
				<Grid container spacing={3}>
					<Grid item md={12}>
						<div style={{ maxHeight: 200, overflow: "auto" }}>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>Parcela</TableCell>
										<TableCell>Tipo</TableCell>
										<TableCell>Vencimento</TableCell>
										<TableCell align="right">Valor</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{props.pedido.aParcela.map((parcela, index) => {
										return (
											<TableRow key={parcela.cParcela}>
												<TableCell>{parcela.cParcela}</TableCell>
												<TableCell>{parcela.CTIPO}</TableCell>
												<TableCell>{formatDateToLocale(parcela.dVencimento)}</TableCell>
												<TableCell align="right">
                          {parcela.nValor.toLocaleString(
                            "pt-BR",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )}
												</TableCell>
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</div>
					</Grid>
				</Grid>
			</Paper>
		</React.Fragment>
	);
};

export default PedidoResumo;
